module.exports = __webpack_public_path__ + "img/achievement2.a7785742.png";